// extracted by mini-css-extract-plugin
module.exports = {"label":"FormLoginPhoneNumber_label__2D2Qc","required":"FormLoginPhoneNumber_required__3u8lj"};